// #region Global Imports
import * as React from 'react';
import cx from 'classnames';
// #endregion Global Imports
// #region Local Imports
import { gql } from '@generated/gql';
import styles from './Ad.module.sass';
import type { IProps } from './Adition.d';
// #endregion Local Imports

export const AdFragment = gql(/* GraphQL */ `
  fragment AdFragment on NodeAd {
    id: uuid
    image: fieldImage {
      entity {
        ...ImageFragment
      }
    }
    label: entityLabel
    email: fieldEmail
    link: fieldLink {
      uri
    }
  }
`);

export const Ad: React.FunctionComponent<IProps.Ad> = ({
  image,
  link,
  email,
}) => (
  <div className={cx(styles.Ad__root, 'Ad__root')}>
    <div className={styles.Ad__img}>
      <a
        href={email !== '' ? `mailto:${String(email)}` : link}
        rel="noopener noreferrer"
        target="_blank"
      >
        {/* <Image image={image} /> */}
      </a>
    </div>
  </div>
);
